import managementApi from '@utils/managementApi';

export type PreferenceCenterUrlResponse = {
  success: boolean;
  data?: { url: string };
  error?: string;
};

export async function fetchPreferenceCenterUrl() {
  const { data } = await managementApi.get<PreferenceCenterUrlResponse>(
    '/v2/preference-center-url',
  );
  return data;
}
